export default function Marquee({ items }) {
  const row = items.map((i) => `${i}  ·  `).join("");
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden bg-[#F3ECE0] border-y border-[#241C1A]/10 py-4 select-none"
    >
      <div className="marquee-track flex whitespace-nowrap font-display italic text-lg sm:text-xl text-[#6E625E]">
        <span>{row.repeat(4)}</span>
        <span>{row.repeat(4)}</span>
      </div>
    </div>
  );
}
